import React, { FC } from "react"
import { graphql } from "gatsby"

import { CardFragmentFragment, CardLpFragmentFragment, ContentfulLpResourcesBlock } from "@graphqlTypes"

import Cards, { CARDS_VARIANTS } from "@components/Cards/Cards"

import LpSection from "../LpSection/LpSection"

import "./ResourcesBlock.scss"

const ResourcesBlock: FC<ContentfulLpResourcesBlock> = ({
  background,
  contentful_id,
  includeBackground,
  marginBottom,
  resources,
  text,
  title,
  useDarkMode,
}) => (
  <LpSection
    background={background}
    className="ResourcesBlock"
    includeBackground={includeBackground}
    marginBottom={marginBottom}
    text={text}
    title={title}
    uniqueId={contentful_id}
    useDarkMode={useDarkMode}
  >
    <div className="container">
      {resources && resources.length > 0 && (
        <Cards
          items={resources as Array<CardFragmentFragment | CardLpFragmentFragment>}
          variant={CARDS_VARIANTS.SMALL}
        />
      )}
    </div>
  </LpSection>
)

export const ResourcesBlockFragment = graphql`
  fragment ResourcesBlockFragment on ContentfulLpResourcesBlock {
    contentful_id
    title
    text {
      raw
    }
    resources {
      __typename
      ... on ContentfulPost {
        ...CardFragment
      }
      ... on ContentfulLandingPage {
        ...CardLpFragment
      }
    }
    background
    includeBackground
    marginBottom
    useDarkMode
  }
`

export default ResourcesBlock
